export const genColumnKey = (key, index) => {
    if (key) {
        return Array.isArray(key) ? key.join('-') : key.toString()
    }
    return `${index}`
}

export const sortColumns = arr => {
    return arr
        .sort((a, b) => a._sort - b._sort)
        .map(v => {
            if (v.children?.length) {
                return {
                    ...v,
                    children: sortColumns(v.children),
                }
            }

            return v
        })
}

export const getTrueColumns = arr => {
    return arr.map(({ _sort, _fixed, _show, _disabled, _width, children, ...rest }) => {
        if (children?.length) {
            return {
                ...rest,
                width: _width,
                fixed: _fixed,
                lock: !!_fixed,
                children: getTrueColumns(children),
            }
        }

        return {
            ...rest,
            width: _width,
            fixed: _fixed,
            lock: !!_fixed,
        }
    })
}

export const filterColumns = arr => {
    return arr
        .map(v => {
            if (v.children?.length) {
                const children = filterColumns(v.children)

                if (children.length) {
                    return {
                        ...v,
                        children: filterColumns(v.children),
                    }
                }

                return null // 过滤后没有子级时需过滤父级
            }

            return v
        })
        .filter(Boolean)
        .filter(v => v._show)
}

export const splitColumns = columns => {
    const leftColumns = sortColumns(columns.filter(v => v._fixed === true || v._fixed === 'left'))
    const centerColumns = sortColumns(columns.filter(v => !v._fixed))
    const rightColumns = sortColumns(columns.filter(v => v._fixed === 'right'))

    return {
        leftColumns,
        centerColumns,
        rightColumns,
        allColumns: [...leftColumns, ...centerColumns, ...rightColumns],
    }
}

/**
 * @param permission 参考结构 permissionPoint.printDeliver
 * @param columnKeyMapper {string:string[]}
 * */
export function parseExcludeKeys(permission, columnKeyMapper) {
    if (!permission) {
        return []
    }
    return permission.filter(_ => !_.value).map(_ => (columnKeyMapper ? columnKeyMapper[_.key] : _.key))
}

/**
 * 是否隐藏成交单价，用于商品列的商品信息（当前仅打单用到）
 * @param permission 参考结构 permissionPoint.printDeliver
 **/
export function isHideOrderAmount(permission) {
    if (!permission) {
        return false
    }
    let found = permission.filter(_ => _.key === 'ORDER_DEAL_PRICE' && !_.value)
    return !!found.length
}
